import { render, staticRenderFns } from "./InitWizard.vue?vue&type=template&id=cd7b49e4&"
import script from "./InitWizard.vue?vue&type=script&lang=js&"
export * from "./InitWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports